import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environmentConfig } from '../../config/config';

const baseQuery = async (args, api, extraOptions) => {
  const result = await fetchBaseQuery({
    baseUrl: environmentConfig.LAMBDA_URL.CATALOG_PRODUCTS,
  })(args, api, extraOptions);
  return result;
};

export const propertyApi = createApi({
  reducerPath: 'api',
  baseQuery,
  endpoints: (builder) => ({
    fetchCatalogProducts: builder.query({
      query: ({ page, perPage, search, from, excludeFrom }) => ({
        url: `/`,
        params: {
          page,
          per_page: perPage,
          search,
          from,
          excludeFrom, // for the direct brands
          last_evaluated_key:
            JSON.parse(localStorage.getItem("lastEvaluatedKey"))?.val ||
            undefined,
        },
      }),
    }),
  }),
});

export const { useFetchCatalogProductsQuery } = propertyApi;
